/**
 * QuoteEngineBoard — Iter-156 · Phase 3.
 * Renders the canonical NECS Commercial Quote Engine inside the
 * command center of Finance / Sales / Customer Service.
 */
import CommercialQuoteEngine from '../CommercialQuoteEngine';

export default function QuoteEngineBoard() {
  return (
    <div className="space-y-2" data-testid="quote-engine-board">
      <p className="text-[10px] uppercase tracking-widest text-zinc-500 mb-2">
        Live Multifamily &amp; 12-vertical commercial engine. Bank, Stadium, and Airport reveal Strategic-Enterprise inputs (vault_handling, secure_area_count, events_per_month, event_duration_hours, tsa_security_zones).
      </p>
      <CommercialQuoteEngine />
    </div>
  );
}
